import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquisButtonModule } from '@tn-equis/core/components/button';
import { PostFooterComponent } from './post-footer/post-footer.component';

import { FooterComponent } from './footer.component';
import { PreFooterComponent } from './pre-footer/pre-footer.component';
import { BodyFooterComponent } from './body-footer/body-footer.component';
import LinkModule from '../link/link.module';
import ButtonDownloadAppModule from '../button-download-app/button-download-app.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    FooterComponent,
    PreFooterComponent,
    BodyFooterComponent,
    PostFooterComponent,
  ],
  imports: [
    CommonModule,
    EquisButtonModule,
    LinkModule,
    ButtonDownloadAppModule,
    DirectivesModule,
  ],
  exports: [FooterComponent],
})
export default class FooterModule {
  public static component = FooterComponent;
}
